// @ts-nocheck
// Team-lead KPI row: live roster counts from the SSE feed plus today's call
// counters from team-lead-stats. Clicking a roster tile filters the group
// board below to that state.
import React from 'react';
import { HAIRLINE, TONE, nf } from './teamUi';

function KpiTile({ label, value, sub, tone, active, onClick }) {
  const toneClass = tone ? TONE[tone].text : 'text-foreground';
  const interactive = typeof onClick === 'function';
  return (
    <button
      type="button"
      disabled={!interactive}
      onClick={onClick}
      className={`rounded-2xl border bg-card p-3 text-left shadow-sm transition-colors ${HAIRLINE} ${
        interactive ? 'hover:bg-muted/40' : 'cursor-default'
      } ${active ? 'ring-2 ring-primary/40' : ''}`.trim()}
    >
      <div className="truncate text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
        {label}
      </div>
      <div className={`mt-1.5 truncate text-[22px] font-semibold leading-none tracking-tight tabular-nums ${toneClass}`}>
        {nf(value)}
      </div>
      {sub ? <div className="mt-1.5 truncate text-[10px] text-muted-foreground">{sub}</div> : null}
    </button>
  );
}

export default function TeamKpiStrip({ counts, totals, stateFilter, onStateFilter, queueWaiting }) {
  const tiles = [
    { key: 'total', label: 'Agents', value: counts.total, sub: `${counts.online} online` },
    { key: 'available', label: 'Available', value: counts.available, tone: 'good', sub: 'Ready for calls', state: 'available' },
    { key: 'onCall', label: 'On call', value: counts.onCall, tone: 'call', sub: 'Talking now', state: 'onCall' },
    { key: 'break', label: 'On break', value: counts.onBreak, tone: 'warn', sub: 'Off the floor', state: 'break' },
    { key: 'offline', label: 'Offline', value: counts.offline, tone: 'off', sub: 'Not logged in', state: 'offline' },
    { key: 'queue', label: 'In call group', value: queueWaiting, tone: queueWaiting > 0 ? 'crit' : undefined, sub: 'Customers waiting' },
    { key: 'calls', label: 'Calls today', value: totals.total, sub: `${nf(totals.inbound)} in · ${nf(totals.outbound)} out` },
    { key: 'connected', label: 'Answered', value: totals.connected, tone: 'good', sub: `${nf(totals.failed)} failed · ${nf(totals.abandoned)} abandoned` },
  ];

  return (
    <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4 xl:grid-cols-8">
      {tiles.map((t) => (
        <KpiTile
          key={t.key}
          label={t.label}
          value={t.value}
          sub={t.sub}
          tone={t.tone}
          active={t.state ? stateFilter === t.state : false}
          onClick={
            t.state && onStateFilter
              ? () => onStateFilter(stateFilter === t.state ? null : t.state)
              : undefined
          }
        />
      ))}
    </div>
  );
}
